const HELP_TARGET_SELECTOR = (helpId) => `[data-help-id="${helpId}"]`;
export const getHelpTarget = (helpId) => {
    if (!helpId)
        return null;
    return document.querySelector(HELP_TARGET_SELECTOR(helpId));
};
export const getHelpTargetSelector = (helpId) => HELP_TARGET_SELECTOR(helpId);
